import React, { Component } from "react";

import { ListGroup, ListGroupItem, Image } from "react-bootstrap";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import UsersService from "../../services/users-service";
import FileService from '../../services/files-service';

import "./style.css";

class SideBar extends Component {
    constructor(props) {
        super(props);

        const storedCredenials = UsersService.sharedInstance.getStoredCredentials();
        const loginResponse = storedCredenials.loginResponse;
        const userType = loginResponse.data[0].User_Type;
        const {permission} = loginResponse;

        const pages = this.validatePages(userType,permission);

        this.state = {
          logo:null,
          pages:pages,
          storedCredenials: storedCredenials
        }
    }

    validatePages = (type,permission = {}) =>{
      const temporary = [
        {name: "Dashboard", icon: "home"},
        {name: "Comm Log", icon: "comment-alt"},
        {name: "Incidents", icon: "exclamation-triangle"},
        {name: "Dispatch", icon: "phone-square"},
        {name: "Txt Commander", icon: "comment-alt"},
        {name: "Assignments", icon: "tasks"},
        {name: "Push Notifications", icon: "bell"},
        {name: "Tour Confirmation", icon: "map-marker-alt"},
        {name: "Forms", icon: "sticky-note"},
        {name: "Binder", icon: "notes-medical"},
        {name: "eLearning", icon: "book-reader"},
        {name: "HR Commander", icon: "users"},
        {name: "Client Commander", icon: "users"},
        {name: "Visitor Management", icon: "users"},
        {name: "Activity Log", icon: "tasks"},
        {name: "Settings", icon: "cog"}
      ];

      let pages = [];

      if(Object.keys(permission).length){
        for(let x = 0; x <  (temporary).length; x++){
          const current = temporary[x];
          let {name} = current;

          if(name == "eLearning"){
            name = "e-Learning";
          }
          
          if(permission[name]){
            pages.push(current);
          }
        }
      }else{
        pages = temporary;
      }

      if(type === 'Super'){
        pages.push({name:'Archon',icon:'user'});
      }

      pages.push({name:'Logout',icon:'sign-out-alt'});

      return pages;
    }

    componentDidMount(){
      this.getSiteLogo();
    }

    getSiteLogo(){
      const that = this;
      const {storedCredenials} = this.state;
      const login = storedCredenials.loginResponse;
      const data = login.data[0];

      const type = 'site_logo';
      const {token} = login.token_data;
      const license = data.User_License;
      const auth_username = data.User_ID;

      const param = {
        type,
        token,
        license,
        auth_username
      };

      FileService.sharedInstance.getLogo(param,response => {
        if(response.success){
          const {data} = response;

          this.setState({ logo:data });
        }else{
          alert(response.message);
        }
      });
    }

    render() {
        const {storedCredenials,logo} = this.state;
        const loginResponse = storedCredenials.loginResponse;
        return (
            <div className="page-wrapper">
                <Image className="menu-logo" src={logo} alt={'Site Logo'} />
                <h1 className="menu-title">CSA360</h1>
                <h5 className="menu-subtext">Dynamic Security Signal Measurement Platform</h5>

                <div className="user-name">
                    <FontAwesomeIcon className="icon" icon="user"/>
                    {loginResponse ? loginResponse.data[0].User_ID : ""}
                </div>

                <ListGroup className="menu-items">
                {
                  this.state.pages.map((page)=>{
                    var buttonTextColor  = page.name == this.props.currentPage ? null : "white";
                    var className = page.name == this.props.currentPage ? "active menu-item" : "menu-item";
                    return (<ListGroupItem key={page.name}
                                style={{color: buttonTextColor}}
                                className={className}
                                onClick={()=>{
                                    window.location.hash=page.name;
                                    this.props.pageChange(page.name);
                                  }}>
                                {/* <Image src={require("../../assets/icons/dashboard.png")} className="icon"/> */}
                                <FontAwesomeIcon  color={buttonTextColor} className="icon" icon={page.icon}/>{page.name}
                            </ListGroupItem>)
                  })
                }

                </ListGroup>
                <div className="version-text-div">
                    <h5 className="version-text">Version 5.0.0</h5>
                </div>
            </div>
        );
    }
}

export default SideBar;
